<template>
  <component :is="currentComponent" />
</template>
<script lang="ts">
export default {
  name: 'YCascader'
}
</script>
<script lang="ts" setup>
import isMobile from '../../utils/is-mobile'
import MobileCascader from './cascaderMobile.vue'
import PcCascader from './cascaderPc.vue'

const currentComponent = isMobile() ? MobileCascader : PcCascader
</script>
